import z, {ZodSchema} from "zod"

import {getRegion} from "./regionManager"
import {ApiError} from "./ApiError"

function get(endpoint: string, options: RequestInit = {}) {
	return req(endpoint, {...options, method: "GET"})
}

export async function getJson<T>(endpoint: string, schema: ZodSchema<T>, options: RequestInit = {}): Promise<T> {
	const data = await req(endpoint, {...options, method: "GET"})
	const result = schema.safeParse(data)
	if (!result.success) {
		console.error("Error parsing JSON", z.treeifyError(result.error), endpoint)
		// for backwards compatibility, we'll return the raw data if the schema parsing fails
		return data as T
	}
	return result.data
}

export async function postJson<T>(
	endpoint: string,
	schema: ZodSchema<T>,
	body?: any,
	options: RequestInit = {},
): Promise<T> {
	const data = await req(endpoint, {...options, method: "POST", body: JSON.stringify(body)})
	const result = schema.safeParse(data)
	if (!result.success) {
		console.error("Error parsing JSON", z.treeifyError(result.error), endpoint)
		throw result.error
	}
	return result.data
}

function post(endpoint: string, body?: any, options: RequestInit = {}) {
	return req(endpoint, {...options, method: "POST", body: JSON.stringify(body)})
}

// Change return type to unknown after the API is updated to return the correct type
function req(endpoint: string, options: RequestInit): Promise<any> {
	return new Promise((resolve, reject) => {
		fetch(url(endpoint), options)
			.then((res) => {
				const contentType = res.headers.get("Content-Type")
				const isJSON = contentType && contentType.includes("application/json")
				const promise = isJSON && res.status !== 204 ? res.json() : res.text()
				promise.then((body) => (res.status >= 400 ? reject(new ApiError(body, res.status)) : resolve(body)))
			})
			.catch(() => {
				reject(new ApiError("Network error", 500))
			})
	})
}

function url(endpoint: string) {
	const region = getRegion()
	return region.url(endpoint)
}

export {get, post}
